import { PeekBox, PeekChip, PeekGrid, PeekPaper, PeekTab, PeekTabs, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import React from "react";
export const TabsLayout = ({ tabs, onTabChange, activeTab, TabAction, TabContent, tabSpacing = true, tabContentSize = "medium", tabSxProps = {}, }) => {
    const theme = useTheme();
    const handleTabChange = (_event, value) => {
        onTabChange(value);
    };
    if (!activeTab) {
        return null;
    }
    return (React.createElement(PeekBox, { sx: { minHeight: "inherit", maxHeight: "inherit", overflow: "hidden" } },
        React.createElement(PeekGrid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "center", sx: { borderBottom: `1px solid ${theme.palette.grey[200]}` } },
            React.createElement(PeekGrid, { item: true },
                React.createElement(PeekTabs, { value: activeTab, orientation: "horizontal", onChange: handleTabChange, "aria-label": "Tabs Tabs", sx: {
                        zIndex: 20,
                        position: "relative",
                        "& .MuiTabs-flexContainer": { gap: tabSpacing ? theme.spacing(2.5) : 0 },
                    } }, tabs.map(({ value, label, labelBadgeContent, disabled, icon: Icon }) => {
                    const id = `${value}-tab`;
                    return (React.createElement(PeekTab, { key: `${value}-tab`, id: id, disabled: disabled, icon: Icon, iconPosition: "start", "aria-controls": id, sx: tabSxProps, label: React.createElement(PeekTypography, { variant: tabContentSize === "medium" ? "h4" : "h5", display: "contents", alignItems: "center" },
                            typeof label === "string" ? label : label.defaultMessage,
                            (labelBadgeContent === null || labelBadgeContent === void 0 ? void 0 : labelBadgeContent.count) !== undefined && (React.createElement(PeekChip, { variant: "filled", label: React.createElement(PeekTypography, { variant: "body2", fontWeight: "fontWeightBold" }, labelBadgeContent === null || labelBadgeContent === void 0 ? void 0 : labelBadgeContent.count), 
                                //@ts-ignore
                                color: (labelBadgeContent === null || labelBadgeContent === void 0 ? void 0 : labelBadgeContent.color) || (activeTab === value ? "primary" : "info"), sx: {
                                    ml: 0.5,
                                } }))), value: value }));
                }))),
            !!TabAction && React.createElement(PeekGrid, { item: true }, TabAction)),
        !!TabContent && (React.createElement(PeekPaper, { sx: {
                borderTopLeftRadius: "unset",
                boxShadow: "none",
                "> div": { px: 0 },
                maxHeight: "inherit",
                overflow: "hidden",
            }, role: "tabpanel", id: `${activeTab}-tabPanel`, "aria-labelledby": `${activeTab}-tab` }, TabContent))));
};
export default TabsLayout;
